<template>
  <div v-if="loading" :class="`loading-overlay ${isBlue ? 'blue-loading-overlay' : ''} ${isWhite ? 'white-loading-overlay' : ''}`">
		<div class="loading-image">
			<img class="stage-1" src="@/common/assets/icons/loading/Loading_akkodis_logo_1.svg" alt="platform">
			<img class="stage-2" src="@/common/assets/icons/loading/Loading_akkodis_logo_2.svg" alt="platform">
			<img class="stage-3" src="@/common/assets/icons/loading/Loading_akkodis_logo_3.svg" alt="platform">
			<img class="stage-4" src="@/common/assets/icons/loading/Loading_akkodis_logo_4.svg" alt="platform">
		</div>

		<div v-if="text" class="loading-main-text">
			{{text}}
		</div>
		<div v-if="description" class="loading-description">
			{{description}}
		</div>
		<button v-if="buttonText" class="cancel-loading-button" @click="onCancelClick">
			{{ buttonText }}
		</button>

	</div>
</template>
<script>
import Vue from "vue";
import loaderService from '@/common/services/loader-service';

export default {
	name: "Loading",
	data() {
		return {
			loading: false,
			isBlue: false,
			isWhite: false,
			text: '',
			description: '',
			buttonText: '',
		};
	},
	methods: {
		onCancel(){},
		onCancelClick(){
			this.onCancel();
			this.hide();
		},
		show({text = '', description = '', buttonText = '', onCancel, isBlue = false, isWhite = false}) {
			this.loading = true;
			this.text = text;
			this.description = description;
			this.buttonText = buttonText;
			this.isBlue = isBlue;
			this.isWhite = isWhite
			if(typeof onCancel === 'function'){
				this.onCancel = onCancel;
			}else{
				this.onCancel = () => {};
			}
		},
		hide() {
			this.loading = false;
			this.text = '';
			this.description = '';
			this.buttonText = '';
			this.isBlue = false;
			this.onCancel = () => {};
		},
		setServiceMethods() {
			loaderService.setMethods(this.show, this.hide, () => this.loading);
		}
	},
	mounted() {
		this.setServiceMethods();
	},
	created() {
		Vue.prototype.$loader = {
			show: this.show,
			hide: this.hide,
			isOpen: () => this.loading
		};
	},
	/*
	HOW TO USE:
		Use the loader in the component like:

			this.$loader.show({
				text: 'Loading...',
				description: 'This may take a while',
				buttonText: 'Cancel',
				isBlue: true,
				onCancel: () => {
					console.log('This is example function')
				}
			});
	 */
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";
.loading-overlay{
	position: fixed;
	z-index: 101;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding-top: 50vh;
	background-color: rgba(0, 0, 0, 0.8);
	display: flex;
	justify-content: flex-start;
	align-items: center;
	color: white;
	font-size: 20px;
	flex-direction: column;

	&.blue-loading-overlay{
		background-color: $newsletter-hover-background;
	}

	&.white-loading-overlay{
		background-color: $gop-new-white;
	}

	.loading-main-text{
		color: $color-white-light;
		font-size: 1.5rem;
		margin-bottom: 1rem;
	}
	.loading-description{
		color: $color-grey;
		font-size: 1rem;
	}

	.cancel-loading-button{
		margin-top: 1rem;
		padding: 1rem 3rem;
		font-size: 1rem;
		background-color: $color-hover-button;
		color: rgb(0,0,0,0.8);
		border: 1px solid $color-hover-button;
		cursor: pointer;

	}

	.loading-image{
		display: flex;
		justify-content: center;
		align-items: center;
		img{
			position: absolute;
			width: 7rem;
			height: 7rem;
			user-select: none;
			pointer-events: none;
			margin-bottom: 8rem;
		}
	}

	.stage-1{
		animation: opacity1 2s linear infinite;
	}
	.stage-2{
		animation: opacity2 2s linear infinite;
	}
	.stage-3{
		animation: opacity3 2s linear infinite;
	}
	.stage-4{
		animation: opacity4 2s linear infinite;
	}

	@keyframes opacity1 {
		0% {
			opacity: 1;
		}
		25% {
			opacity: 0;
		}
		75% {
			opacity: 0;
		}
		100%{
			opacity: 1;
		}
	}
	@keyframes opacity2 {
		0% {
			opacity: 0;
		}
		25% {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		100%{
			opacity: 0;
		}
	}
	@keyframes opacity3 {
		0% {
			opacity: 0;
		}
		25% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
		75% {
			opacity: 0;
		}
		100%{
			opacity: 0;
		}
	}
	@keyframes opacity4 {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 0;
		}
		75% {
			opacity: 1;
		}
		100%{
			opacity: 0;
		}
	}
}
</style>
